(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('CloudPBX', CloudPBX);

    CloudPBX.$inject = ['$resource'];

    function CloudPBX ($resource) {
        var resourceUrl =  'api/cloud-pbxes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
